import api from '@/lib/api';
import type {
  PaginatedResponse,
  DepositPolicy,
  DepositBasis,
  DepositDueTiming,
} from '@pms/shared';

// ─── Query / payload types ────────────────────────────────────────────────────

export interface ListDepositPoliciesQuery {
  propertyId: string;
  search?: string | undefined;
  isActive?: boolean | undefined;
  page?: number | undefined;
  limit?: number | undefined;
}

export interface CreateDepositPolicyPayload {
  propertyId: string;
  name: string;
  code: string;
  basis: DepositBasis;
  value?: number | undefined;
  dueTiming: DepositDueTiming;
  daysBeforeArrival?: number | undefined;
  isDefault?: boolean | undefined;
  isActive?: boolean | undefined;
}

export interface UpdateDepositPolicyPayload {
  name?: string | undefined;
  code?: string | undefined;
  basis?: DepositBasis | undefined;
  value?: number | undefined;
  dueTiming?: DepositDueTiming | undefined;
  daysBeforeArrival?: number | undefined;
  isDefault?: boolean | undefined;
  isActive?: boolean | undefined;
}

// ─── API functions ────────────────────────────────────────────────────────────

export async function fetchDepositPolicies(
  query: ListDepositPoliciesQuery,
): Promise<PaginatedResponse<DepositPolicy>> {
  const { data } = await api.get<PaginatedResponse<DepositPolicy>>(
    '/deposit-policies',
    { params: query },
  );
  return data;
}

export async function createDepositPolicy(
  payload: CreateDepositPolicyPayload,
): Promise<DepositPolicy> {
  const { data } = await api.post<DepositPolicy>('/deposit-policies', payload);
  return data;
}

export async function updateDepositPolicy(
  id: string,
  payload: UpdateDepositPolicyPayload,
): Promise<DepositPolicy> {
  const { data } = await api.patch<DepositPolicy>(
    `/deposit-policies/${id}`,
    payload,
  );
  return data;
}

export async function deleteDepositPolicy(id: string): Promise<void> {
  await api.delete(`/deposit-policies/${id}`);
}
